import React, { useState, useEffect, useContext } from 'react';
import JusticeImage from '../../images/Justice.jpg'; // Import the background image
import MainBackground from '../../images/MainBackground.jpg';
import MainAdImage from '../../images/MainAd.png';
import MainAd1 from '../../images/MainAd1.png'; // Add this import
import { useNavigate, useLocation } from 'react-router-dom';
import SignUp from '../components/SignUp'; // Import SignUp component
import { UserContext } from '../context/UserContext'; // Import UserContext
import Quiz from '../components/Quiz';  // Add this import
import SignIn from '../components/SignIn'; // Add this import

// The home page for the website, with concerned voters and politicians join here options
const MainBody = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(UserContext); // Get login status from context
  const [selectedButton, setSelectedButton] = useState(null);
  const [video, setVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);  // Add this state
  const [showSignIn, setShowSignIn] = useState(false); // Add this new state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Handle initial selection and show content from Vision dropdown
    if (location.state?.initialSelection) {
      setSelectedButton(location.state.initialSelection);
      if (location.state.showVotersContent) {
        // Automatically show voters content
        setSelectedButton('voters');
      } else if (location.state.showPoliticiansContent) {
        // Automatically show politicians content
        setSelectedButton('politicians');
      }
    }

    const fetchVideo = async () => {
      if (selectedButton === 'voters' || selectedButton === 'politicians') {
        try {
          const response = await fetch("/api/tutorialvideos");
          if (response.ok) {
            const data = await response.json();
            // Use video ID 35 for politicians, 30 for voters
            const targetVideoId = selectedButton === 'politicians' ? 37 : 30;
            const targetVideo = data.find(video => video.id === targetVideoId);
            setVideo(targetVideo);
          } else {
            console.error("Failed to fetch tutorial video");
          }
        } catch (error) {
          console.error("Error fetching tutorial video:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchVideo();
  }, [selectedButton, location.state]);

  // Add window resize listener
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Modify the getBackgroundImage function
  const getBackgroundImage = () => {
    if (window.innerWidth <= 926) {
      if (selectedButton) {
        return MainBackground; // Use MainBackground for vision page on mobile
      }
      return JusticeImage; // Changed from MainAd1 to JusticeImage
    }
    return selectedButton ? MainBackground : JusticeImage; // Changed from MainAdImage to JusticeImage
  };

  // Navigate to the main page with the user type and selected button
  //todo: add open signup modal
  const handleVoterSignUp = () => {
    setShowSignUpModal(true); // Show the signup modal
  };

  const handleGoToMain = () => {
    navigate('/main');
  };

  const handlePoliticianSignUp = () => {
    setShowSignUpModal(true);
  };

  // Add this new handler
  const handleQuizClick = () => {
    if (isLoggedIn) {
      setShowQuiz(true);
    } else {
      setShowSignIn(true);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '95vh',
      backgroundColor: '#f5f5f5',
      padding: window.innerWidth <= 926 ? '10px' : '20px',
      paddingTop: window.innerWidth <= 926 ? '0' : '100px',
      backgroundImage: `url(${getBackgroundImage()})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 2,
        width: '100%',
        maxWidth: '1200px',
        marginTop: window.innerWidth <= 926 ? '-50px' : '5%',
        height: window.innerWidth <= 926 ? 'auto' : '100%',
        paddingTop: window.innerWidth <= 926 ? '0' : '0'
      }}>
        {/* Desktop view text styling - commenting out */}
        {/* {!selectedButton && window.innerWidth > 926 && (
          <div style={{
            position: 'absolute',
            top: '-20%',
            left: '32%',
            transform: 'translate(-50%, -50%)',
            zIndex: 3,
            textAlign: 'center',
            width: '100%'
          }}>
            <h1 style={{
              color: '#fff',
              fontSize: '4.5rem',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 30px rgba(0,0,0,0.6)',
              lineHeight: '1.2',
              letterSpacing: '2px',
              WebkitTextStroke: '1px rgba(0,0,0,0.3)'
            }}>
              Take the<br />
              <span style={{
                fontSize: '5rem',
                textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 30px rgba(0,0,0,0.6)',
                WebkitTextStroke: '1px rgba(0,0,0,0.3)'
              }}>
                QUIZ
              </span><br />
              TO WIN!
            </h1>
          </div>
        )} */}

        {/* Mobile view text styling - commenting out */}
        {/* {!selectedButton && window.innerWidth <= 926 && (
          <div style={{
            position: 'absolute',
            top: '5%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 3,
            textAlign: 'center',
            width: '100%'
          }}>
            <h1 style={{
              color: '#fff',
              fontSize: '2.5rem',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 30px rgba(0,0,0,0.6)',
              lineHeight: '1.2',
              letterSpacing: '2px',
              WebkitTextStroke: '1px rgba(0,0,0,0.3)'
            }}>
              Take the<br />
              <span style={{
                fontSize: '3rem',
                textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 30px rgba(0,0,0,0.6)',
                WebkitTextStroke: '1px rgba(0,0,0,0.3)'
              }}>
                QUIZ
              </span><br />
              TO WIN!
            </h1>
          </div>
        )} */}

        {!selectedButton && (
          <>
            {/* Add new headings */}
            <div style={{
              position: 'absolute',
              top: window.innerWidth <= 926 ? '15%' : '5%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 3,
              textAlign: 'center',
              width: '100%'
            }}>
              <h2 style={{
                color: '#fff',
                fontSize: window.innerWidth <= 926 ? '2.5rem' : '3.5rem',
                fontWeight: 'bold',
                lineHeight: '1.2',
                letterSpacing: '2px',
                WebkitTextStroke: '1px rgba(0,0,0,0.3)',
                marginBottom: '20px'
              }}>
                POWER TO THE PEOPLE
              </h2>
              <h3 style={{
                color: '#fff',
                fontSize: window.innerWidth <= 926 ? '1.5rem' : '2.0rem',
                letterSpacing: '1px'
              }}>
                Bridge between the People and Politicians
              </h3>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: window.innerWidth <= 926 ? '20px' : '40px',
              marginTop: window.innerWidth <= 926 ? '100px' : '100px',
              paddingTop: '10px'
            }}>
              <div style={{
                display: 'flex',
                gap: window.innerWidth <= 926 ? '20px' : '100px',
                flexDirection: window.innerWidth <= 926 ? 'column' : 'row',
                justifyContent: 'center',
                alignItems: 'center',
                paddingTop: window.innerWidth <= 926 ? '0' : '20px',
                width: '100%'
              }}>
                <button style={{
                  padding: '12px 25px',
                  fontSize: '1rem',
                  backgroundColor: '#007bff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, background-color 0.2s',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                  width: window.innerWidth <= 926 ? '90%' : '200px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '5px'
                }}
                onClick={() => setSelectedButton('voters')}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#0056b3';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#007bff';
                  e.target.style.transform = 'scale(1)';
                }}>
                  <span style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '1.2rem' }}>VOTERS</span>
                  <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>Click Here</span>
                </button>

                <button
                  onClick={() => setSelectedButton('politicians')}
                  style={{
                    padding: '12px 25px',
                    fontSize: '1rem',
                    backgroundColor: '#28a745',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                    width: window.innerWidth <= 926 ? '90%' : '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '5px',
                    transition: 'transform 0.2s, background-color 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#218838';
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#28a745';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  <span style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '1.2rem' }}>POLITICIANS</span>
                  <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>Click Here</span>
                </button>
              </div>
            </div>

            {/* Commenting out the bottom section with quiz button and political match text */}
            {/* <div style={{
              position: 'fixed',
              bottom: window.innerWidth <= 926 ? '40px' : '60px',
              left: '0',
              right: '0',
              width: '100%',
              display: 'flex',
              flexDirection: window.innerWidth <= 926 ? 'column' : 'row',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              paddingBottom: '10px',
              backgroundColor: 'transparent',
              gap: window.innerWidth <= 926 ? '10px' : '0'
            }}>
              {window.innerWidth <= 926 ? (
                <>
                  <h2 style={{
                    fontWeight: 'bold',
                    color: '#fff',
                    textAlign: 'center',
                    letterSpacing: '2px',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    width: 'auto',
                    whiteSpace: 'nowrap',
                    fontSize: '1.2rem',
                    position: 'relative',
                    marginBottom: '5px'
                  }}>
                    Find your political match and Win!
                  </h2>

                  <button
                    style={{
                      padding: '12px 20px',
                      fontSize: '1.2rem',
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                      width: '50%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      animation: 'pulseAndGlow 2s infinite',
                      transition: 'all 0.3s ease-in-out'
                    }}
                    onClick={handleQuizClick}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.1)';
                      e.target.style.boxShadow = '0 8px 20px rgba(220,53,69,0.6), 0 0 30px rgba(220,53,69,0.3)';
                      e.target.style.background = 'linear-gradient(45deg, #c82333, #dc3545)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.boxShadow = '0 4px 6px rgba(220,53,69,0.2)';
                      e.target.style.background = 'linear-gradient(45deg, #dc3545, #c82333)';
                    }}
                  >
                    <span style={{ 
                      fontWeight: 'bold', 
                      textTransform: 'uppercase', 
                      fontSize: '1.3rem',
                      color: '#fff',
                      textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
                      whiteSpace: 'nowrap'
                    }}>
                      CLICK TO QUIZ
                    </span>
                  </button>
                </>
              ) : (
                <>
                  <button
                    style={{
                      padding: '15px 25px',
                      fontSize: '1.3rem',
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                      width: '220px',
                      marginRight: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      animation: 'pulseAndGlow 2s infinite',
                      transition: 'all 0.3s ease-in-out'
                    }}
                    onClick={handleQuizClick}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.1)';
                      e.target.style.boxShadow = '0 8px 20px rgba(220,53,69,0.6), 0 0 30px rgba(220,53,69,0.3)';
                      e.target.style.background = 'linear-gradient(45deg, #c82333, #dc3545)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.boxShadow = '0 4px 6px rgba(220,53,69,0.2)';
                      e.target.style.background = 'linear-gradient(45deg, #dc3545, #c82333)';
                    }}
                  >
                    <span style={{ 
                      fontWeight: 'bold', 
                      textTransform: 'uppercase', 
                      fontSize: '1.4rem',
                      color: '#fff',
                      textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
                      whiteSpace: 'nowrap'
                    }}>
                      CLICK TO QUIZ
                    </span>
                  </button>

                  <h2 style={{
                    fontWeight: 'bold',
                    color: '#fff',
                    textAlign: 'center',
                    letterSpacing: '2px',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    width: 'auto',
                    whiteSpace: 'nowrap',
                    fontSize: '1.5rem',
                    position: 'relative',
                    marginLeft: '20px'
                  }}>
                    Find your political match and Win!
                  </h2>
                </>
              )}
            </div> */}
          </>
        )}

        {selectedButton === 'voters' && (
          <>
            <div style={{
              width: '100%',
              marginTop: (() => {
                if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                  return '80px'; // Reduced from 80px for phone portrait
                } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                  return '0px';
                }
                return '10px';
              })(),
              paddingTop: (() => {
                if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                  return '20px';
                } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                  return '0px';
                }
                return '10px';
              })(),
              position: 'relative',
              display: 'flex',
              flexDirection: window.innerWidth <= 926 ? 'column' : 'row',
              alignItems: window.innerWidth <= 926 ? 'center' : 'flex-start',
              justifyContent: window.innerWidth <= 926 ? 'center' : 'flex-start',
              overflow: 'visible',
              paddingRight: window.innerWidth <= 926 ? '20px' : '0',
              paddingLeft: window.innerWidth <= 926 ? '20px' : '0'
            }}>
              <div style={{
                position: 'relative',
                width: '100%',
                display: 'flex',
                flexDirection: window.innerWidth <= 926 ? 'column' : 'row',
                alignItems: window.innerWidth <= 926 ? 'center' : 'flex-start',
                justifyContent: window.innerWidth <= 926 ? 'center' : 'space-between',
                paddingRight: window.innerWidth <= 926 ? '10px' : '0',
                overflow: 'visible',
                marginTop: window.innerWidth <= 926 ? '20px' : '0',
                marginLeft: window.innerWidth > 926 ? '40px' : '0'
              }}>
                <div style={{ 
                  width: window.innerWidth <= 926 ? '100%' : 'auto',
                  textAlign: window.innerWidth <= 926 ? 'center' : 'left'
                }}>
                  <h1 style={{
                    fontWeight: 'bold',
                    color: '#fff',
                    textTransform: 'none',
                    letterSpacing: '2px',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    marginBottom: window.innerWidth <= 926 ? '20px' : '10px',
                    marginTop: window.innerWidth <= 926 ? '20px' : '10px',
                    overflow: 'visible',
                    fontSize: window.innerWidth <= 926 ? '20px' : '32px',
                    whiteSpace: window.innerWidth <= 926 ? 'nowrap' : 'normal',
                    display: 'inline-block'
                  }}>
                    Why Join UrVOTE?
                  </h1>
                </div>
                <div style={{
                  position: window.innerWidth <= 926 ? 'relative' : 'absolute',
                  right: window.innerWidth <= 926 ? 'auto' : '-170px',
                  top: window.innerWidth <= 926 ? 'auto' : '50%',
                  transform: window.innerWidth <= 926 ? 'none' : 'translateY(-50%)',
                  zIndex: 3,
                  display: window.innerWidth <= 926 ? 'flex' : 'block',
                  justifyContent: window.innerWidth <= 926 ? 'center' : 'flex-start',
                  width: window.innerWidth <= 926 ? '100%' : 'auto'
                }}>
                  <button 
                    onClick={isLoggedIn ? handleGoToMain : handleVoterSignUp}
                    style={{
                      padding: '8px 20px',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      transition: 'transform 0.2s, background-color 0.2s',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                  >
                    {isLoggedIn ? 'Go to Main Page' : 'Continue Sign Up'}
                  </button>
                </div>
              </div>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              width: '100vw',
              height: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? 'calc(100vh - 200px)' : 'calc(100vh - 150px)',
              padding: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '10px 20px' : '0 40px',
              flexDirection: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? 'column' : 'row',
              gap: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '10px' : '20px',
              marginTop: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '5px' : '0',
              overflowY: 'auto',
              scrollbarWidth: 'thin',
              scrollbarColor: 'rgba(255,255,255,0.5) transparent',
              paddingBottom: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '100px' : '0'
            }}>
              {/* Left side - Video */}
              <div style={{
                width: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '100%'; // Phone portrait
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '50%'; // Phone landscape
                  }
                  return '65%'; // Desktop - slightly reduced width
                })(),
                height: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '250px'; // Phone portrait - reduced height
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '60vh'; // Phone landscape - reduced height
                  }
                  return '65vh'; // Desktop - reduced height
                })(),
                backgroundColor: '#000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '5px' : '0',
                position: 'relative',
                minHeight: '250px' // Reduced minimum height
              }}>
                <div style={{
                  width: '100%',
                  height: '100%',
                  position: 'relative'
                }}>
                  <iframe
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: '8px'
                    }}
                    src={video?.video_url || 'about:blank'}
                    title="UrVote Introduction"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              {/* Right side - Vision Statement */}
              <div style={{
                width: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '100%'; // Phone portrait
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '50%'; // Phone landscape
                  }
                  return '50%'; // Desktop
                })(),
                height: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '250px'; // Phone portrait - matched with video height
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '60vh'; // Phone landscape - matched with video height
                  }
                  return '65vh'; // Desktop - matched with video height
                })(),
                padding: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '0 10px' : '0 40px',
                overflowY: 'auto',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.5) transparent',
                marginTop: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '5px' : '0',
                minHeight: '250px' // Reduced minimum height
              }}>
                <h2 style={{
                  color: '#fff',
                  marginBottom: '10px',
                  textAlign: 'left',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                }}>
                  UrVote Vision Statement
                </h2>
                <div style={{
                  color: '#fff',
                  fontSize: '1.3rem',
                  lineHeight: '1.6',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                  paddingRight: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '10px' : '0'
                }}>
                  <h4 style={{
                    marginBottom: '10px',
                    fontWeight: 'bold'
                  }}>
                    Rebuilding Trust in Democracy—Together
                  </h4>
                  <p style={{
                    marginBottom: '10px'
                  }}>
                    At UrVote, we believe every Australian deserves a real voice in the decisions that shape their future. Our vision is to restore trust in government by putting power back into the hands of the people—where it belongs.
                  </p>
                  <p style={{
                    marginBottom: '10px'
                  }}>
                    We empower communities to actively participate in democracy through transparent voting, local projects, and direct connection with their representatives. UrVote isn't just a platform—it's a movement to make democracy work for everyone, every day, not just on election day.
                  </p>
                  <p>
                    Join us in creating a future where citizens and leaders work side by side to build stronger, fairer communities.
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {selectedButton === 'politicians' && (
          <>
            <div style={{
              width: '100%',
              marginTop: (() => {
                if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                  return '80px'; // Phone portrait
                } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                  return '0px'; // Phone landscape
                }
                return '10px'; // Laptop
              })(),
              paddingTop: (() => {
                if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                  return '20px'; // Phone portrait
                } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                  return '0px'; // Phone landscape
                }
                return '10px'; // Laptop
              })(),
              position: 'relative',
              display: 'flex',
              flexDirection: window.innerWidth <= 926 ? 'column' : 'row',
              alignItems: window.innerWidth <= 926 ? 'center' : 'flex-start',
              justifyContent: window.innerWidth <= 926 ? 'center' : 'flex-start',
              overflow: 'visible',
              paddingRight: window.innerWidth <= 926 ? '20px' : '0',
              paddingLeft: window.innerWidth <= 926 ? '20px' : '40px'
            }}>
              <div style={{
                position: 'relative',
                width: '100%',
                display: 'flex',
                flexDirection: window.innerWidth <= 926 ? 'column' : 'row',
                alignItems: window.innerWidth <= 926 ? 'center' : 'flex-start',
                justifyContent: window.innerWidth <= 926 ? 'center' : 'flex-start',
                paddingRight: window.innerWidth <= 926 ? '10px' : '0',
                overflow: 'visible',
                marginTop: window.innerWidth <= 926 ? '20px' : '0'
              }}>
                <div style={{ 
                  width: window.innerWidth <= 926 ? '100%' : 'auto',
                  textAlign: window.innerWidth <= 926 ? 'center' : 'left'
                }}>
                  <h1 style={{
                    fontWeight: 'bold',
                    color: '#fff',
                    textAlign: 'inherit',
                    textTransform: 'none',
                    letterSpacing: '2px',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    marginBottom: window.innerWidth <= 926 ? '20px' : '10px',
                    marginTop: window.innerWidth <= 926 ? '20px' : '10px',
                    overflow: 'visible',
                    fontSize: window.innerWidth <= 926 ? '20px' : '32px',
                    whiteSpace: window.innerWidth <= 926 ? 'nowrap' : 'normal',
                    display: 'inline-block'
                  }}>
                    Why Join UrVOTE?
                  </h1>
                </div>
                <div style={{
                  position: window.innerWidth <= 926 ? 'relative' : 'absolute',
                  right: window.innerWidth <= 926 ? 'auto' : '-170px',
                  top: window.innerWidth <= 926 ? 'auto' : '50%',
                  transform: window.innerWidth <= 926 ? 'none' : 'translateY(-50%)',
                  zIndex: 3,
                  display: window.innerWidth <= 926 ? 'flex' : 'block',
                  justifyContent: window.innerWidth <= 926 ? 'center' : 'flex-start',
                  width: window.innerWidth <= 926 ? '100%' : 'auto'
                }}>
                  <button 
                    onClick={isLoggedIn ? handleGoToMain : handlePoliticianSignUp}
                    style={{
                      padding: '8px 20px',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      transition: 'transform 0.2s, background-color 0.2s',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                  >
                    {isLoggedIn ? 'Go to Main Page' : 'Continue Sign Up'}
                  </button>
                </div>
              </div>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              width: '100vw',
              height: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? 'calc(100vh - 200px)' : 'calc(100vh - 150px)',
              padding: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '10px 20px' : '0 40px',
              flexDirection: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? 'column' : 'row',
              gap: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '10px' : '20px',
              marginTop: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '5px' : '0',
              overflowY: 'auto',
              scrollbarWidth: 'thin',
              scrollbarColor: 'rgba(255,255,255,0.5) transparent',
              paddingBottom: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '40px' : '0'
            }}>
              {/* Left side - Video */}
              <div style={{
                width: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '100%'; // Phone portrait
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '50%'; // Phone landscape
                  }
                  return '65%'; // Desktop - slightly reduced width
                })(),
                height: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '250px'; // Phone portrait - reduced height
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '60vh'; // Phone landscape - reduced height
                  }
                  return '65vh'; // Desktop - reduced height
                })(),
                backgroundColor: '#000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '5px' : '0',
                position: 'relative',
                minHeight: '250px' // Reduced minimum height
              }}>
                <div style={{
                  width: '100%',
                  height: '100%',
                  position: 'relative'
                }}>
                  <iframe
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: '8px'
                    }}
                    src={video?.video_url || 'about:blank'}
                    title="UrVote Introduction"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              {/* Right side - Vision Statement */}
              <div style={{
                width: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '100%'; // Phone portrait
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '50%'; // Phone landscape
                  }
                  return '50%'; // Desktop
                })(),
                height: (() => {
                  if (window.innerWidth <= 926 && window.innerHeight > window.innerWidth) {
                    return '250px'; // Phone portrait - matched with video height
                  } else if (window.innerWidth <= 926 && window.innerHeight <= window.innerWidth) {
                    return '60vh'; // Phone landscape - matched with video height
                  }
                  return '65vh'; // Desktop - matched with video height
                })(),
                padding: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '0 10px' : '0 40px',
                overflowY: 'auto',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.5) transparent',
                marginTop: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '5px' : '0',
                minHeight: '250px' // Reduced minimum height
              }}>
                <h2 style={{
                  color: '#fff',
                  marginBottom: '10px',
                  textAlign: 'left',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                }}>
                  UrVote Vision Statement
                </h2>
                <div style={{
                  color: '#fff',
                  fontSize: '1.3rem',
                  lineHeight: '1.6',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                  paddingRight: window.innerWidth <= 926 && window.innerHeight > window.innerWidth ? '10px' : '0'
                }}>
                  <h4 style={{
                    marginBottom: '10px',
                    fontWeight: 'bold'
                  }}>
                    Rebuilding Trust in Democracy—And Earning the Support to Win
                  </h4>
                  <p style={{
                    marginBottom: '10px'
                  }}>
                    At UrVote, we understand that trust is the key to winning elections and building lasting support. Our vision is to empower politicians who are ready to lead with transparency, listen to their communities, and demonstrate real alignment with voter priorities.
                  </p>
                  <p style={{
                    marginBottom: '10px'
                  }}>
                    UrVote helps you connect directly with engaged citizens, gain valuable insights into voter sentiment, and show you're the candidate who truly represents their values. It's not just about technology—it's a platform that helps you build trust, increase visibility, and grow the voter base you need to secure your seat.
                  </p>
                  <p>
                    Join us to rebuild trust in government—and give your electorate a reason to believe in you.
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Add an overlay to ensure text readability */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.2)',  // Reduced opacity from 0.3 to 0.2
        zIndex: 1
      }} />

      {showSignUpModal && (
        <SignUp 
          onClose={() => setShowSignUpModal(false)}
          showModal={true}
        />
      )}

      {/* Add SignIn modal */}
      {showSignIn && (
        <SignIn
          onClose={() => setShowSignIn(false)}
          onSignInSuccess={() => {
            setShowSignIn(false);
            setShowQuiz(true);
          }}
        />
      )}

      {/* Add Quiz Modal */}
      {showQuiz && (
        <Quiz onClose={() => setShowQuiz(false)} />
      )}
    </div>
  );
};

export default MainBody;
